import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Constants from "./utilities/Constants";
import Strings from "./utilities/StringSelector";

class DevicesStatistics extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      ioControllers: 0,
      ioDevices: 0,
      supervisors: 0,
      notProfinet: 0
    };
  }

  retrieveData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "deviceStatistics", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        ioControllers: data.ioControllers,
        ioDevices: data.ioDevices,
        supervisors: data.supervisors,
        notProfinet: data.notProfinet
      }));
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveData, 5000) });
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
  }

  render() {
    const statistics = [
      { value: this.state.ioControllers, label: "IO Controllers" },
      { value: this.state.ioDevices, label: "IO Devices" },
      { value: this.state.supervisors, label: Strings.SUPERVISORS },
      { value: this.state.notProfinet, label: Strings.OTHER_DEVICES },
    ];

    return (
      <div className="ts-device-statistics">
        {statistics.map((item) => (
          <div className="ts-device-stat-card" key={item.label}>
            <span className="ts-device-stat-value">{item.value}</span>
            <span className="ts-device-stat-label">{item.label}</span>
          </div>
        ))}
      </div>
    );
  }}


export default withRouter(DevicesStatistics);